import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Dashboard summary tile. Renders a label + icon + big number.
 * Pass `to` to make the whole card a keyboard-accessible button that
 * navigates via React Router. Pass `warn` to flip the visual to a
 * red-tinted variant for low-stock / urgency states.
 */
export default function StatCard({ label, value, icon: Icon, warn, testId, to }) {
  const navigate = useNavigate();
  const clickable = !!to;
  const handleClick = clickable ? () => navigate(to) : undefined;
  return (
    <div
      data-testid={testId || `stat-${label.toLowerCase().replace(/\s+/g, "-")}`}
      onClick={handleClick}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
              }
            }
          : undefined
      }
      className={`bg-white border rounded-xl p-4 sm:p-5 transition-all ${
        warn ? "border-red-200 bg-red-50" : "border-zinc-200"
      } ${
        clickable
          ? "cursor-pointer hover:shadow-md hover:-translate-y-px hover:border-zinc-300 focus:outline-none focus:ring-2 focus:ring-zinc-900 focus:ring-offset-1"
          : ""
      }`}
    >
      <div className="flex items-center justify-between mb-2">
        <span className={`text-xs font-medium ${warn ? "text-red-700" : "text-zinc-500"}`}>{label}</span>
        <Icon size={16} weight="bold" className={warn ? "text-red-600" : "text-zinc-400"} />
      </div>
      <div className={`text-2xl sm:text-3xl font-semibold ${warn ? "text-red-900" : "text-zinc-950"}`}>{value}</div>
    </div>
  );
}
